module.exports = __webpack_public_path__ + "img/ranger_small.9a6b64c9.png";